export class Disclaimer{
  id:number;
  disclaimer?:string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/disclaimer.ts